import { Component, Fragment } from 'react';
import { Redirect } from 'react-router-dom';
import styled from 'styled-components';
import MessageBus from '@restore/messagebus';
import webcorePath, { retainNavbar } from './webcorePathService';
import ChurnZeroService from '../../../services/churnzero/churnzero-service';
import LoaderPage from '../../../ui_refresh/pages/LoaderPage';
import Header from '../../../ui_refresh/components/Header';
import SplitIOTreatment from '../../splitio/splitioTreatment';
import { connect } from 'react-redux';
import { headerOverlayToggle } from '../../../ui_refresh/utils/headerOverlayToggle';
import Auth from '../../../ui_refresh/services/Auth';
import AuthService from '../../../services/auth/authService';
import AuthContext from '../../../context/AuthContext';
import { getToken } from '../../../ui_refresh/utils/getToken';
import KeycloakTimeoutHandler from '../../../ui_refresh/components/KeycloakTimeoutHandler';
import { getTourViewed, setTourViewed } from '../../../ui_refresh/services/TourService';

const PlayNavBar = styled.div`
  z-index: ${({ showNavBar }) => (showNavBar ? '100' : '0')};
  position: absolute;
  width: 100%;
  top: 0px;
  left: 0px;
`;
class IframeWebcore extends Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    const { match } = props;
    this.state = {
      redirect_path: '',
      showNavBar: retainNavbar(match.params.pathType),
      showLoading: true,
    };
    this.messageBus = new MessageBus();
  }

  unload(path) {
    this.setState({
      ...this.state,
      redirect_path: path,
      showNavBar: true,
    });
  }

  componentDidMount() {
    this.messageBus.subscribe('home', ({ path }) => {
      this.unload(path);
    });

    this.messageBus.subscribe('absoluteHome', ({ absoluteUrl }) => {
      window.location = absoluteUrl;
    });

    this.messageBus.subscribe('back', () => {
      this.props.history.goBack();
    });

    this.messageBus.subscribe('token_request', async () => {
      // Prefer the Keycloak token (held in memory on the keycloak instance).
      // In a Keycloak realm the legacy localStorage token is never populated,
      // so falling back to AuthService.getAuthToken() would hand webcore
      // `undefined` and its /users/network call would 401. Fall back to the
      // legacy token only when Keycloak has no session (legacy login flow).
      let token;
      try {
        token = await getToken(this.context);
      } catch {
        token = AuthService.getAuthToken();
      }
      this.messageBus.publish('auth', { token });
      this.setState({ ...this.state, showLoading: false });
    });

    this.messageBus.subscribe('hideLoader', () => {
      this.setState({ ...this.state, showLoading: false });
    });

    this.messageBus.subscribe('keep_alive', ({ token }) => {
      AuthService.setAuthToken(token);
    });

    this.messageBus.subscribe('webcore_keep_alive', ({ requestID }) => {
      Auth.keepAlive().then((response) => {
        if (response) {
          this.messageBus.respond('webcore_keep_alive', requestID, response.new_auth);
        }
      });
    });

    this.messageBus.subscribe('record_game_duration', ({ duration }) =>
      ChurnZeroService.recordGameDuration(Math.round(duration / 60.0))
    );
    this.messageBus.subscribe('toggle_nav_bar', ({ showNavBar }) => this.setState({ ...this.state, showNavBar }));
    headerOverlayToggle('off');

    this.messageBus.subscribe('getTourViewed', (payload) => {
      this.messageBus.respond('getTourViewed', payload.requestID, getTourViewed(payload.data.tourName));
    });

    this.messageBus.subscribe('setTourViewed', (tourName) => {
      setTourViewed(tourName);
    });
  }

  componentWillUnmount() {
    headerOverlayToggle('on');
  }

  render() {
    const { redirect_path, showLoading, showNavBar } = this.state;
    const { token, match, user } = this.props;

    const url = webcorePath(match.params.pathType, token, 1, match.params.id, match.params);
    if (redirect_path) {
      return <Redirect push to={redirect_path}></Redirect>;
    }
    return (
      <>
        <KeycloakTimeoutHandler />
        <SplitIOTreatment featureName={'DC-42-UI-refresh'} treatmentValue="on" trafficType="business-group">
          {(treatment) => {
            if (treatment === 'on') {
              const iFrameCssClasses =
                'tw-w-full tw-h-full tw-top-0 tw-left-0 tw-fixed ' + (showLoading ? 'tw--z-10' : 'tw-z-50');
              return (
                <Fragment>
                  <SplitIOTreatment featureName="Webcore_new_ui" trafficType="business-group" treatmentValue="on">
                    {(treatment) => {
                      if (treatment === 'on') {
                        return (
                          <PlayNavBar showNavBar={showNavBar}>
                            <Header user={user} />
                          </PlayNavBar>
                        );
                      }
                      return null;
                    }}
                  </SplitIOTreatment>
                  <iframe
                    id="webcore_iframe"
                    allow="geolocation; microphone; camera; screen-wake-lock; fullscreen;"
                    className={iFrameCssClasses}
                    src={url}
                    title="Webcore"
                  ></iframe>
                  {showLoading && <LoaderPage />}
                </Fragment>
              );
            } else if (treatment === 'off') {
              return (
                <iframe
                  id="webcore_iframe"
                  allow="geolocation; microphone; camera; screen-wake-lock; fullscreen;"
                  className="tw-w-full tw-h-full tw-top-0 tw-left-0 tw-fixed tw-z-50"
                  src={url}
                  title="Webcore"
                ></iframe>
              );
            } else {
              return null;
            }
          }}
        </SplitIOTreatment>
      </>
    );
  }
}

const withState = connect((state) => {
  const { webcore, user } = state;

  return {
    webcore: webcore,
    user: user,
  };
});

export default withState(IframeWebcore);
